import { render, staticRenderFns } from "./Dossier.vue?vue&type=template&id=52dbfa82&scoped=true"
import script from "./Dossier.vue?vue&type=script&lang=js"
export * from "./Dossier.vue?vue&type=script&lang=js"
import style0 from "./Dossier.vue?vue&type=style&index=0&id=52dbfa82&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52dbfa82",
  null
  
)

export default component.exports